import { getLabelSpec, translateLabel } from './validationLabels';

// --- Badge per validazione banche ---
interface ValidationBadgeProps {
  type: "error" | "action" | "info";
  value: string;
}

/**
 * Traduce una label di /validate. Non lancia mai su una label sconosciuta:
 * il vocabolario vive in `validationLabels.ts`, qui resta solo la resa grafica.
 */
export const translateBadgeValue = (_type: "error" | "action" | "info", value: string) =>
  translateLabel(value);

export const ValidationBadge: React.FC<ValidationBadgeProps> = ({ type, value }) => {
  const isError = type === "error";
  const isAction = type === "action";
  const isInfo = type === "info";

  const spec = getLabelSpec(value);
  // Una info bloccante non deve sembrare innocua quanto una puramente informativa.
  const emphasised = isInfo && spec?.blocks;
  // Il verde vuol dire "niente da segnalare" ed e' riservato al badge Completato.
  // Una info non bloccante resta una segnalazione — "Origine non raggiungibile" o
  // "Ultima indicizzazione fallita" in verde si leggono come un via libera.
  const notice = isInfo && !spec?.blocks && Boolean(spec);

  return (
    <span
      title={spec?.action}
      className={`px-3 py-1 rounded-full text-xs font-semibold
        ${isError ? "bg-statePendingBg text-statePendingText" : ""}
        ${isAction ? "bg-stateToValidateBg text-stateToValidateText" : ""}
        ${emphasised ? "bg-stateToValidateBg text-stateToValidateText" : ""}
        ${notice ? "bg-gray-100 text-gray-600" : ""}
        ${isInfo && !emphasised && !notice ? "bg-stateCompletedBg text-stateCompletedText" : ""}
      `}
    >
      {translateLabel(value)}
    </span>
  );
};
